<navbar></navbar>

<div class="main-content" id="main">
  <router-outlet></router-outlet>
</div>
<p-toast></p-toast>
<custom-popup></custom-popup>
